// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__1w_tD","badgeIcon":"Badge_badgeIcon__1b91R","badgeTextLabel":"Badge_badgeTextLabel__1eSrX"};